import React from 'react';
import './photoCard.css';
import useSignedImage from '../../../../hooks/useSignedImage';

const PhotoCard = ({ data, onClick }) => {
    // Use the signed image hook to handle Wasabi URLs
    const { imageUrl: signedImageUrl, isLoading: imageLoading, error: imageError } = useSignedImage(data, '/default-restaurant.png');
    
    return (
        <div className="photo-card__container" onClick={onClick}>
            <img src={signedImageUrl} className="photo-card__image" alt="Thumbnail" onClick={onClick} />
        </div>
    );
};

export default PhotoCard;

